import React, { Component } from "react";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import AndtDMultiEmailWrapper from "../../../../Components/CustomWrappers/AntDMultipleEmailBox";
import AntDSelectWrapper from "../../../../Components/CustomWrappers/AntDSelectWrapper";
import AndtDRadioButtonWrapper from "swfrontend/MDM/MDMAntdWrappers/RadioButtonWrapper";
import AntDMultipleTextBoxWrapper from "../../../../Components/CustomWrappers/AntDMultipleTextBox";
import { QUERY } from "../../../../constants";

class AdditionalDetails extends Component {
  reference = new URLSearchParams(this.props.history.location.search).get(
    QUERY.reference
  );

  render() {
    const {
      editDataAvailable,
      editFormData,
      formRef,
      isDisabled,
      isIndia,
      is_AN13,
      isAN13Update,
      toggleHTMLControls,
      registrationFields,
      isRequired,
      optionalFields,
      isAN22,
      disabledTeleMobEmail,
      req_op_fields,
    } = this.props;
    return (
      <div className="row form-box">
        <legend className="form-legend">Additional Details</legend>
        {!is_AN13 && !isAN22 && (
          <div
            className="col-lg-6 col-md-12"
            hidden={"product" in registrationFields}
          >
            <AntDSelectWrapper
              decorator="product"
              id="product"
              required={isAN13Update ? false : true}
              disabled={isDisabled}
              label="Product Details"
              message="Select Product Details"
              placeholder="Select Product Details"
              app="masters"
              entity="productdetails"
              validators=""
              options={[]}
              allowClear={true}
              primary_key_field="id"
              multiple={"multiple"}
              formRef={formRef}
              prefixId={true}
            />
          </div>
        )}

        {is_AN13 && (
          <div className="col-lg-6 col-md-12">
            <AndtDRadioButtonWrapper
              decorator="is_billing_shipping_same"
              id="is_billing_shipping_same"
              required="true"
              disabled={isDisabled}
              label="Is Billing And Shipping Address Same ?"
              message="Select Billing And Shipping Address"
              placeholder="Select Billing And Shipping Address"
              radioType="radio"
              validators=""
              options={[
                { id: "true", name: "Yes", value: true },
                { id: "false", name: "No", value: false },
              ]}
              formRef={formRef}
            />
          </div>
        )}

        {!is_AN13 && (
          <>
            {!this.reference && (
              <div className="col-lg-6 col-md-12">
                <AndtDRadioButtonWrapper
                  decorator="is_billing_shipping_same"
                  id="is_billing_shipping_same"
                  required="true"
                  disabled={
                    "is_billing_shipping_same" in req_op_fields["S"]
                      ? true
                      : isDisabled
                  }
                  label="Is Billing And Shipping Address Same ?"
                  message="Select Billing And Shipping Address"
                  placeholder="Select Billing And Shipping Address"
                  radioType="radio"
                  validators=""
                  options={[
                    { id: "true", name: "Yes", value: true },
                    { id: "false", name: "No", value: false },
                  ]}
                  formRef={formRef}
                />
              </div>
            )}

            {!("director_details" in registrationFields) && (
              <div className="col-lg-6 col-md-12">
                <AndtDRadioButtonWrapper
                  decorator="director_details_status"
                  id="director_details_status"
                  required="true"
                  disabled={isDisabled}
                  label="Is Directors/CEO/MD Details Available ?"
                  message="Select Director Details"
                  placeholder="Select Director Details"
                  radioType="radio"
                  validators=""
                  onChangeRadio={toggleHTMLControls}
                  options={[
                    { id: "true", name: "Yes", value: true },
                    { id: "false", name: "No", value: false },
                  ]}
                  formRef={formRef}
                />
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

export default AdditionalDetails;
